// extracted by mini-css-extract-plugin
export default {"overflow":"ComplaintFormStepper-A51Oh__overflow","step":"ComplaintFormStepper-MWZLz__step"};